<template>
    <div>

      <BCard  class="mb-0">

        <BCardTitle>Series</BCardTitle>
        <div class="">
          <BRow>

            <BCol cols="12" md="4" lg="5" xl="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <vSelect v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{$t('entries')}}</label>
            </BCol>

            <BCol cols="12" md="8" lg="7" xl="6">
              <div class="d-flex align-items-center justify-content-between">
                <BFormInput disabled v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'"  />
                <BButton variant="primary" @click="showAddModal" v-if="ability.can('create', 'serie')"> <span class="text-nowrap">Añadir serie</span> </BButton>
              </div>
            </BCol>

          </BRow>
        </div>

        <!-- Table -->
         <BTable borderless  ref="refDataListTable" class="position-relative mt-2" :items="fetchSeries" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc" >
          <template #cell(name)="data">
                <span> {{ data.item.name }} <br> <small v-if="data.item.is_default"><b>Por defecto</b></small></span>
          </template>

          <template #cell(receipt_serie)="data">
                <span> {{ data.item.receipt_serie }} ({{ data.item.receipt }})</span><br>
          </template>

          <template #cell(corrective_receipt_serie)="data">
                <span> {{ data.item.corrective_receipt_serie }} ({{ data.item.corrective_receipt }})</span><br>
          </template>

          <template #cell(invoice_serie)="data">
                <span> {{ data.item.invoice_serie }} ({{ data.item.invoice }})</span><br>
          </template>

          <template #cell(corrective_invoice_serie)="data">
                <span> {{ data.item.corrective_invoice_serie }} ({{ data.item.corrective_invoice}})</span><br>
          </template>

          <template #cell(expense_serie)="data">
                <span> {{ data.item.expense_serie }} ({{ data.item.expense}})</span><br>
          </template>
          
      

          <template #cell(actions)="data">
            <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">

              <template #button-content> <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" /> </template>

              <BDropdownItem @click="showEditModal(data.item.id)" v-if="ability.can('write', 'serie')">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">{{$t('Edit')}}</span>
              </BDropdownItem>

              <BDropdownItem @click="deletePopupAxios(data.item.id, `series/${data.item.id}`)" v-if="ability.can('delete', 'serie')">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{$t('Delete')}}</span>
              </BDropdownItem>

            </BDropdown>
          </template> 
        </BTable> 

        <!-- Paginate -->
        <div class="mx-2 mb-2">
          <BRow>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
            </BCol>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <BPagination v-model="currentPage" :total-rows="totalData" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text> <feather-icon icon="ChevronLeftIcon" size="18" /> </template>
                <template #next-text> <feather-icon icon="ChevronRightIcon" size="18" /> </template>
              </BPagination>
            </BCol>
          </BRow>
        </div>

      </BCard>

      <SeriesModal @refetch-data="refetchData"/>
    </div>
  </template>

  <script>
  import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BDropdown, BDropdownItem, BPagination, BBadge, BCardTitle} from 'bootstrap-vue'
  import { provide, ref, inject, computed, watch } from '@vue/composition-api';
  import { avatarText } from '@core/utils/filter';
  import ability from '@/libs/acl/ability'
  import popups from '@/hooks/popups'
  import vSelect  from 'vue-select'
  import TextInputValidated from '@/components/forms/TextInputValidated.vue'
  import SeriesModal from './SeriesAddEdit.vue';
  import { getSeries } from '@/composables/serieService';
  import dateUtils from '@/hooks/dateUtils'

  export default {
    components: { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BDropdown, BDropdownItem, BPagination, vSelect, BBadge, TextInputValidated, BCardTitle, SeriesModal },
    emits: ['re-render-notes'],
    setup(props, {emit}){
      const { deletePopupAxios } = popups()
      const refDataListTable = ref(null)
      const seriesModal=ref(null)
      const addModal = ref(null)
      const serieId = ref (null)
      const series = ref(null)
      const { formatDate } = dateUtils()

      // Query params
      const perPage = ref(10)
      const totalData = ref(0)
      const currentPage = ref(1)
      const perPageOptions = [10, 25, 50, 100]
      const searchQuery = ref('')
      const sortBy = ref('start_date')
      const isSortDirDesc = ref(false)
      
      // Table
      const tableColumns = [
        { key: 'name', label: 'Nombre' },
        { key: 'receipt_serie', label: 'Recibo' },
        { key: 'corrective_receipt_serie', label: 'Recibo recitificativo' },
        { key: 'invoice_serie', label: 'Factura' },
        { key: 'corrective_invoice_serie', label: 'Factura rectificativa' },
        { key: 'expense_serie', label: 'Gasto' },
        { key: 'actions', label: 'Acciones' }
      ]

      const group = inject('group')
      provide('seriesModal', seriesModal)
      provide('serieId', serieId)
      provide('addModal', addModal)

      const dataMeta = computed(() => {
          const localItemsCount = refDataListTable.value ? refDataListTable.value.localItems.length: 0
          return {
              from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
              to: perPage.value * (currentPage.value - 1) + localItemsCount,
              of: totalData.value,
          }
      });


      const fetchSeries = async function () {
        let data = {
          group: group.value.id
        }
        let response = await getSeries(data)
        return response.data.series 
      }

      fetchSeries()

      const refetchData = function() {
          refDataListTable.value.refresh()
          emit('re-render-notes')
      }

      const showAddModal = () => {
        addModal.value=true
        seriesModal.value.show()
      }

      const showEditModal = (id) => {
        serieId.value=id
        addModal.value=false
        seriesModal.value.show()
      }

      watch([currentPage, perPage, searchQuery], () => {
        refetchData()
      })

      return {
        avatarText,
        tableColumns,
        perPage,
        currentPage,
        totalData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refDataListTable,
        ability,
        deletePopupAxios,
        seriesModal, 
        series, 
        fetchSeries,
        formatDate,
        showAddModal,
        showEditModal,
        refetchData
      }
    }
  }
  </script>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
